/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export enum ExternalCheckIdScopeApiModel {
  System = 'system',

  Business = 'business',

  Loyalty = 'loyalty',

  Pos = 'pos',

  Terminal = 'terminal'
}
